"use client"

import React, { useEffect, useState, useRef } from 'react'
import './nbar.css'
import { FaBars } from "react-icons/fa";
import { IoCloseOutline } from "react-icons/io5";
import Somfinlogo from '../../assets/somfinlogo.png'

const NAV_LINKS = [
  { id: 0, link: "/", caption: 'Home' },
  { id: 1, link: "/individual", caption: 'Individual' },
  { id: 2, link: "/business", caption: 'Business' },
  { id: 3, link: "/explore", caption: 'Explore' },
  { id: 4, link: "/builder", caption: 'Builder' },
  { id: 5, link: "/finlit", caption: 'Financial Literacy' },
];

const MORE_LINKS = [
  { id: 6, link: "/contact", caption: 'Contact Us' },
  { id: 7, link: "/term", caption: 'Terms & Conditions' },
  { id: 8, link: "/privacy", caption: 'Privacy Policy' },
  { id: 9, link: "/aboutus", caption: 'About Us' },
];

const Navbar = () => {
  const [navOpen, setNavOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('/');
  const [dropOpen, setDropOpen] = useState(false);
  const dropRef = useRef(null);

  useEffect(() => {
    if (window.innerWidth > 1024) setNavOpen(true);
    if (typeof window !== 'undefined') setActiveLink(window.location.pathname);
  }, []);

  // Close dropdown on outside click
  useEffect(() => {
    const handler = (e) => {
      if (dropRef.current && !dropRef.current.contains(e.target)) setDropOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleNavClick = (link) => {
    setActiveLink(link);
    setDropOpen(false);
    if (window.innerWidth <= 1024) setNavOpen(false);
  };

  const isMoreActive = MORE_LINKS.some(l => activeLink === l.link);

  return (
    <div className="nbar">
      <div className="nbar__inner">
        <a href="/" className="nlogo" onClick={() => { setActiveLink('/'); if (window.innerWidth <= 1024) setNavOpen(false); }}>SOMFIN
          <img src={Somfinlogo} alt="Somfin Logo" className="somfin-logo" />
        </a>

        {navOpen && (
          <ul className="nbar__links">
            {NAV_LINKS.map(({ id, link, caption }) => (
              <li key={id}>
                <a
                  href={link}
                  className={`nbar__link${activeLink === link ? ' nbar__link--active' : ''}`}
                  onClick={() => handleNavClick(link)}
                >
                  {caption}
                </a>
              </li>
            ))}
            {/* Dropdown */}
            <li className="nbar__dropdown" ref={dropRef}>
              <button
                className={`nbar__link nbar__link--drop${dropOpen ? ' nbar__link--drop-open' : ''}${isMoreActive ? ' nbar__link--active' : ''}`}
                onClick={() => setDropOpen(p => !p)}
                type="button"
              >
                More <span className="nbar__drop-arrow">{dropOpen ? '▴' : '▾'}</span>
              </button>
              {dropOpen && (
                <div className="nbar__dropdown-menu">
                  {MORE_LINKS.map(({ id, link, caption }) => (
                    <a
                      key={id}
                      href={link}
                      className={`nbar__dropdown-link${activeLink === link ? ' nbar__dropdown-link--active' : ''}`}
                      onClick={() => handleNavClick(link)}
                    >
                      {caption}
                    </a>
                  ))}
                </div>
              )}
            </li>
          </ul>
        )}

        <button className="nbar__toggle" onClick={() => setNavOpen(!navOpen)} type="button" aria-label="Menu">
          {navOpen ? <IoCloseOutline /> : <FaBars />}
        </button>
      </div>
    </div>
  );
};

export default Navbar;